import { Routes } from '@angular/router';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { EsrSubmitComponent } from './esr-submit/esr-submit.component';
import { TroubleShootingComponent } from './trouble-shooting/trouble-shooting.component';
import { StepsEs2000Component } from './trouble-shooting/steps-es2000/steps-es2000.component';
import { TrainingMaintenanceComponent } from './landing-page/training-maintenance/training-maintenance.component';
import { FeedbackComponent } from './resolved/feedback/feedback.component';
import { FeedbackSummaryComponent } from './resolved/summary/summary.component';
import { EsrSummaryComponent } from './trouble-shooting/esr-summary/esr-summary.component';
import { EsrSupportComponent } from './trouble-shooting/esr-support/esr-support.component';
import { EsrSupportDetailsComponent } from './trouble-shooting/esr-support-details/esr-support-details.component';
import { ChatSupportComponent } from './chatSupport/chatSupport.component';
import { CloseRequestComponent } from './closeRequest/closeRequest.component';
import { EsrEditComponent } from './trouble-shooting/esr-edit/esr-edit.component';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';
import { AccountInfoComponent } from './welcome-page/account-info/account-info.component';
// import { ScanQrCodeComponent } from './welcome-page/scanQrCode/scanQrCode.component';
import { AccountDetailsComponent } from './welcome-page/account-details/account-details.component';
import { ThankYouComponent } from './trouble-shooting/thank-you/thank-you.component';
import { ContactUsComponent } from './trouble-shooting/contactUs/contact-us.component';
import { MachineTypesComponent } from './landing-page/machine-types/machine-types.component';
import { WelcomeTroubleShootPageComponent } from './trouble-shooting/welcome-trouble-shoot-page/welcome-trouble-shoot-page.component';
import { PoorResultsEhtComponent } from './trouble-shooting/poor-results-eht/poor-results-eht.component';
import { StepsEhtComponent } from './trouble-shooting/steps-eht/steps-eht.component';
import { StepsEltComponent } from './trouble-shooting/steps-elt/steps-elt.component';
import { PoorResultsEltComponent } from './trouble-shooting/poor-results-elt/poor-results-elt.component';
import { SupportComponent } from './trouble-shooting/support/support.component';
import { DeviceTypesComponent } from './trouble-shooting/device-types/device-types.component';
import { PoorResultsEultComponent } from './trouble-shooting/poor-results-eult/poor-results-eult.component';
import { StepsEultComponent } from './trouble-shooting/steps-eult/steps-eult.component';
import { StepsEuhtComponent } from './trouble-shooting/steps-euht/steps-euht.component';
import { PoorResultsEuhtComponent } from './trouble-shooting/poor-results-euht/poor-results-euht.component';
import { StepsEh500sComponent } from './trouble-shooting/steps-eh500s/steps-eh500s.component';
import { ResultIssuesEh500sComponent } from './trouble-shooting/result-issues-eh500s/result-issues-eh500s.component';

export const routes: Routes = [
  { path: 'training', component: TrainingMaintenanceComponent },
  { path: 'esrSummary', component: EsrSummaryComponent },
  { path: 'esrSupport/:accountNumber', component: EsrSupportComponent },
  {
    path: 'devices/:accountNumber',
    component: DeviceTypesComponent,
  },
  { path: 'support/:accountNumber', component: SupportComponent },
  { path: 'esrSupportDetails', component: EsrSupportDetailsComponent },
  { path: 'esrEdit', component: EsrEditComponent },
  { path: 'esrSubmit', component: EsrSubmitComponent },
  { path: 'feedback', component: FeedbackComponent },
  { path: 'feedbackSummary', component: FeedbackSummaryComponent },
  { path: 'chat', component: ChatSupportComponent },
  { path: 'close', component: CloseRequestComponent },
  // { path: 'qrCode', component: ScanQrCodeComponent },
  { path: 'accountInfo', component: AccountInfoComponent },
  { path: 'accountDetails', component: AccountDetailsComponent },
  // { path: 'scanAccNumber', component: ScanQrCodeComponent },
  { path: 'thankYou', component: ThankYouComponent },
  { path: 'contactUs', component: ContactUsComponent },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    data: { hideHeader: true },
  },
  { path: 'troubleshoot/:accountNumber', component: LandingPageComponent },
  {
    path: 'troubleShootDesc/:accountNumber',
    component: WelcomeTroubleShootPageComponent,
  },
  { path: 'issues/:accountNumber', component: TroubleShootingComponent },
  { path: 'issue-list/:accountNumber', component: TroubleShootingComponent },
  {
    path: 'poorresultseht/:accountNumber',
    component: PoorResultsEhtComponent,
  },
  {
    path: 'poorresultselt/:accountNumber',
    component: PoorResultsEltComponent,
  },
  {
    path: 'poorresultseult/:accountNumber',
    component: PoorResultsEultComponent,
  },
  {
    path: 'poorresultseuht/:accountNumber',
    component: PoorResultsEuhtComponent,
  },
  {
    path: 'resultIssuesEh500s/:accountNumber/:stepId',
    component: ResultIssuesEh500sComponent,
  },
  {
    path: 'issueses2000/:accountNumber/:stepId',
    component: StepsEs2000Component,
  },
  {
    path: 'issueseht/:accountNumber/:stepId',
    component: StepsEhtComponent,
  },
  {
    path: 'issueselt/:accountNumber/:stepId',
    component: StepsEltComponent,
  },
  {
    path: 'issueseult/:accountNumber/:stepId',
    component: StepsEultComponent,
  },
  {
    path: 'issueseuht/:accountNumber/:stepId',
    component: StepsEuhtComponent,
  },
  {
    path: 'issueseh500s/:accountNumber/:stepId',
    component: StepsEh500sComponent,
  },
  {
    path: 'dishmachineModel/:accountNumber',
    component: MachineTypesComponent,
  },
  { path: ':id', component: WelcomePageComponent },
];
